import maplibregl from 'maplibre-gl';
import GeoJSON from 'geojson';
import "../../../styles/results/list.scss";
import axios from "axios";
import { stringify } from "qs";
import { bind_swiper } from "../swiper";

const {site, language_switch, is_vm } = window.tg;
const mapVersion = 'v2'
const mapUrl = 'https://tiles.locationiq.com/'+mapVersion+'/streets/vector.json?key='; // LocationIQ style specification url (recommended for maplibre)
const iconBasepath = '/cdn/images/stays/integrations/leaflet/';
const iconAvailPng = '/map-marker-small.png'
const iconUnavailPng = '/map-marker-unavailable.png'
const key = is_vm ? 'pk.6537bbbbca6841d84b5aab72c79fc55b' : 'pk.65bfcd4f74a29a6fd2c0e62cc587c59d';
const zoomThreshold = 11;

let smallRadius, medRadius, largeRadius, smallRadiusShadow, medRadiusShadow, largeRadiusShadow;
switch (site) {
    case 'tg' :
        smallRadius = 'rgba(6, 79, 147)';
        medRadius = 'rgba(18, 122, 210)';
        largeRadius = 'rgba(5, 33, 148)';
        smallRadiusShadow = 'rgba(6, 79, 147, 0.2)';
        medRadiusShadow = 'rgba(18, 122, 210, 0.2)';
        largeRadiusShadow = 'rgba(5, 33, 148, 0.2)';
        break;
    case 'vy' :
        smallRadius = 'rgba(56, 211, 155)';
        medRadius = 'rgba(76, 170, 135)';
        largeRadius = 'rgba(0, 133, 84)';
        smallRadiusShadow = 'rgba(56, 211, 155, 0.2)';
        medRadiusShadow = 'rgba(76, 170, 135, 0.2)';
        largeRadiusShadow = 'rgba(0, 133, 84, 0.2)';
        break;
    default: // ls
        smallRadius = 'rgba(232, 104, 38)';
        medRadius = 'rgba(207, 65, 15)';
        largeRadius = 'rgba(166, 36, 6)';
        smallRadiusShadow = 'rgba(232, 104, 38, 0.2)';
        medRadiusShadow = 'rgba(207, 65, 15, 0.2)';
        largeRadiusShadow = 'rgba(166, 36, 6, 0.2)';
        break;
}

var maplibreMap = {
    _key: key,
    _map: null,

    _miniLoadedAtZoom: 0,
    _miniLoadedAtLat: 0,
    _miniLoadedAtLng: 0,

    _extensionForIcons: 1.3,
    _movingSensitivity: 3,
      // Whitelabel this below
    _site: site,
    _identifier: 'js-map-canvas',
    _options: { showCenterMarker: true },

    initialize: function (coords, options) {
        this._originalCenter = coords;
        this._options = Object.assign({}, this._options, options || {});

        if (typeof this._options.identifier !== 'undefined' && this._options.identifier !== '') {
            this._identifier = this._options.identifier;
        }

        this._map = new maplibregl.Map({
            container: this._identifier,
            style: mapUrl+this._key,
            attributionControl: false,
            maxZoom: 16,
            minZoom: 3,
            center: coords,
        });

        this.addMapControls();
        this.loadMapIcons();
        this.zoomMapToRegion();
        this.addMapListeners();

    },

    addMapControls: function () {
        this._map.addControl(new maplibregl.NavigationControl(), 'top-left');
        this._map.addControl(new maplibregl.AttributionControl({compact:true}), 'bottom-right');
        this._map.addControl(new maplibregl.ScaleControl({unit: 'metric'}), 'bottom-right');
    },

    loadMapIcons: function () {
        this._map.loadImage(
            iconBasepath + site + iconAvailPng,
            (error, image) => {
                if (error) throw error;
                this._map.addImage('mini-marker', image);
            }
        )
        this._map.loadImage(
            iconBasepath + site + iconUnavailPng,
            (error, image) => {
                if (error) throw error;
                this._map.addImage('mini-marker-unavailable', image);
            }
        )
    },

    zoomMapToRegion: function () {
        if (this._options.fitBounds) {
            this._map.fitBounds([
                [this._options.longMin, this._options.latMin],
                [this._options.longMax, this._options.latMax]
            ]);
        }
    },

    addMapListeners: function () {
        var that = this;

        this._map.on('zoomend', function () {
            var newZoomLevel = that._map.getZoom();
            var zoomDifference = Math.abs(that._miniLoadedAtZoom - newZoomLevel);
            if (zoomDifference > 1) {
                newZoomLevel <= 6 ? that.addMiniMarkers("load") : that.addMiniMarkers("onzoom"); // show loader if zoomed out far
            }
        });


        this._map.on('moveend', function () {
            var center = that._map.getCenter();
            var lat = center.lat;
            var lng = center.lng;

            var bounds = that._map.getBounds();
            var nsSpan = bounds.getNorth() - bounds.getSouth();

            var latchange = parseFloat(lat) - parseFloat(that._miniLoadedAtLat);
            var longchange = parseFloat(lng) - parseFloat(that._miniLoadedAtLng);
            var difference = Math.sqrt(latchange * latchange + longchange * longchange);

            if (difference > (nsSpan / that._movingSensitivity)) {
                that.addMiniMarkers("onmove");
            }
        });
    },

    addMiniMarkers: function () {
        var that = this;
        var lat = this._map.getCenter().lat;
        var lng = this._map.getCenter().lng;
        var zoom = this._map.getZoom();
        var rad = this._map.getRadius();


        if (this._miniRequest) {
            this._miniRequest.abort()
            this._miniRequest = null
        }


        this._miniRequest = $.post("/ajax/map/get_simple_map_marker_points.php", { lat: lat, lng: lng, rad: rad }, function (data) {
            data = JSON.parse(data);
            that.clearMiniMarkers();
            that._miniLoadedAtZoom = zoom;
            that._miniLoadedAtLat = lat;
            that._miniLoadedAtLng = lng;

            that.createMapMarkers(data.data);
        });
    },

    getRadius: function() {
        return this._map.getBounds().getNorthEast().distanceTo(this._map.getBounds().getSouthWest()) / 2000 * this._extensionForIcons;
    },

    createMapMarkers: function (destinationData, event) {
        var geojsonData = GeoJSON.parse(destinationData, {Point: ['latitude', 'longitude']});
        if (event === "onmove" || event === "onzoom") {
            if (this._map.getSource('destinations')) {
                this._map.getSource('destinations').updateData({add: geojsonData.features});
            }

            else {
                this._map.addSource('destinations', {
                    type: 'geojson',
                    data: geojsonData,
                    cluster: true,
                    clusterMaxZoom: 12,
                    clusterRadius: 40,
                    buffer: 0,
                    promoteId: 'establishment_id'
                });
                this.createClustersCircles();
                this.createMiniMarkers();
            }
        }
        else {
            if (this._map.getSource('destinations')) {
                this._map.getSource('destinations').setData(geojsonData);
            }
            else {
                this._map.addSource('destinations', {
                    type: 'geojson',
                    data: geojsonData,
                    cluster: true,
                    clusterMaxZoom: 12,
                    clusterRadius: 40,
                    buffer: 0,
                    promoteId: 'establishment_id'
                });
                this.createClustersCircles();
                this.createMiniMarkers();
            }
        }
    },

    createClustersCircles: function () {
        this._map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'destinations',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    smallRadius,
                    10,
                    medRadius,
                    100,
                    largeRadius
                ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    15,
                    10,
                    15,
                    100,
                    15
                ],
                'circle-stroke-color': [
                    'step',
                    ['get', 'point_count'],
                    smallRadiusShadow,
                    10,
                    medRadiusShadow,
                    100,
                    largeRadiusShadow
                ],
                'circle-stroke-width': 5
            }
        });

        this._map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'destinations',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': '{point_count}',
                'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                'text-size': 12,
            },
            paint: {
                'text-color': '#ffffff'
            }
        });

        this._map.on('click', 'clusters', (e) => {
            const features = this._map.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            });
            const clusterId = features[0].properties.cluster_id;
            this._map.getSource('destinations').getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return;

                    this._map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom
                    });
                }
            );
        });

        this.addChangePointerOnHover('clusters');
    },

    createMiniMarkers: function () {
        this._map.addLayer({
            id: 'mini-markers',
            type: 'symbol',
            source: 'destinations',
            filter: ['all', ['!', ['has', 'point_count']]],
            layout: {
                "icon-image": [
                    "match", ["number", ["get", "availability"]],
                      -1,
                      "mini-marker-unavailable",
                      -2,
                      "mini-marker-unavailable",
                      "mini-marker"
                    ],
                'icon-allow-overlap': true,
                "icon-size": [
                    'case',
                    ['==', ["get", "availability"], -1],
                    0.8,
                    ['==', ["get", "availability"], -2],
                    0.8,
                    1
                    ],
            }
        });

        this.addShowSnippetOnClick('mini-markers');
        this.addChangePointerOnHover('mini-markers');
    },

    addShowSnippetOnClick: function (layerId) {
        var that = this;
        this._map.on('click', layerId, (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            axios({
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                method: 'post',
                url: "/backend/accommodation/generate_map_snippet",
                data: stringify({ id: e.features[0].properties.establishment_id, alloc: e.features[0].properties.allocated, avl: e.features[0].properties.availability}),
            })
            .then (function (response) {
                const data = response.data;
                if (data.success === true && data.data.map_snippet_html) {
                    const html = data.data.map_snippet_html;
                    var popup = new maplibregl.Popup({ closeButton: false, maxWidth: '300px', anchor: 'bottom'})
                        .setLngLat(coordinates)
                        .setHTML(html)
                        .addTo(that._map);

                    that.panToPopup(popup);

                    document.addEventListener('click', function(event) {
                        const el = /** @type {HTMLTextAreaElement} */ (event.target);

                        if (el != undefined && el.classList.contains('js-close-popup')) {
                            popup.remove();
                        }
                    },false);

                    that._map.on('zoomend', function () {
                        var newZoomLevel = that._map.getZoom();
                        if (that._miniLoadedAtZoom > newZoomLevel) { // zooming out
                            if (newZoomLevel < zoomThreshold) {
                                popup.remove()
                              }
                        }

                    });

                    bind_swiper('.js-swiper-map');
                }
            })
        });
    },

    panToPopup: function (popup) {
        const pan = [0, 0];
        const newPoint = this._map.project(popup._lngLat);
        const centerPoint = this._map.project(this._map.getCenter());


        const popupSize = {
            width: popup._container.clientWidth,
            height: popup._container.clientHeight
        }

        const popupRect = popup._container.getBoundingClientRect();
        const mapRect = this._map._container.getBoundingClientRect();

        const popupRelativeLeft = popupRect.x - mapRect.x;
        const popupClippedHorizontally = popupRelativeLeft < 0 || (mapRect.width- popupRelativeLeft - popupSize.width) < 0;
        if (popupClippedHorizontally) {
            pan[0] = newPoint.x - centerPoint.x;
        }

        const popupRelativeTop = popupRect.y - mapRect.y;
        const popupClippedVertically = popupRelativeTop < 0 || (mapRect.height - popupRelativeTop - popupSize.height) < 0;
        if (popupClippedVertically) {
            pan[1] = newPoint.y - centerPoint.y - (popupRect.height / 4); // offset from the top
        }

        if (pan !== [0, 0]) {
            this._map.panBy(pan);
        }
    },

    addChangePointerOnHover: function (layerId) {
        // Change the cursor to a pointer when the it enters a feature in the 'symbols' layer.
        this._map.on('mouseenter', layerId, () => {
            this._map.getCanvas().style.cursor = 'pointer';
        });

        // Change it back to a pointer when it leaves.
        this._map.on('mouseleave', layerId, () => {
            this._map.getCanvas().style.cursor = '';
        });
    }
}

window.tg.maplibreMap = maplibreMap;
